<template>
  <div class="pg">
    <div class="pg-l">
      <div class="pgl-top">
        <div :class="showMore ? 'pglt-group3' : 'pglt-group'">
          <div v-for="(item, index) in topRlist" :key="index" class="pglt-item"
            :style="{ backgroundColor: item.color }">
            {{ item.num }}
            <div class="pglti-posa">{{ item.name }}</div>
          </div>
        </div>
        <div v-show="!showMore" @click="showMore = !showMore" class="btn-show1"><i class="iconfont htoolzk"></i></div>
        <div v-show="showMore" @click="showMore = !showMore" class="btn-show2"><i class="iconfont htoolsq"></i></div>
      </div>
      <div class="pgl-main" :style="{ height: boxHeight + 'px' }">
        <div class="canvas-title">
          <div class="ct-nameg">
            <div v-for="i in canvasList" :key="i.code"
              :style="i.code == canvasCode ? 'border-bottom: ' + ssbgcolor + '2px solid;color:' + ssbgcolor : ''"
              :class="i.code == canvasCode ? 'act-name' : 'ct-name'" @click="canvasClick(i)">{{ i.name }}</div>
          </div>
          <div class="ct-right">
            <el-dropdown trigger="click" @command="handleCommand">
              <div class="dropdown" style="cursor: pointer;">
                {{ timeDate }}<i class="iconfont icon_xiangxia" style="font-size:15px"></i>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="one">近七天</el-dropdown-item>
                <el-dropdown-item command="three">近七月</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div>
          <ChartNca :titleName="ChartNcaname" :obj="ChartNcaobj" class="chart" ref="chart"></ChartNca>
        </div>
      </div>
    </div>
    <div class="pg-r" style="min-width:300px">
      <div class="pgl-top">
        <div class="btn-title"><i class="vxe-icon-info-circle-fill redclass"></i>提示</div>
        <div class="btn-text"><i class="vxe-icon-star-fill colorclass"></i>推荐使用该版的Chrome，能获得最佳体验</div>
        <div class="btn-text"><i class="vxe-icon-star-fill colorclass"></i>需要使用打印功能请先下载打印插件</div>
        <div style="display:flex;justify-content: start;">
          <!-- <div class="btn-xz" :style="'border:'+ssbgcolor+' 1px solid;color:'+ssbgcolor">
            <a href="http://www.ncerp.cn/static/_res/files/Plugin.zip" :style="'color:'+ssbgcolor">下载打印插件</a>
          </div> -->
          <div class="btn-xz plugins" @click="downloadPlugins">下载打印插件</div>
          <div class="btn-xz" :style="'margin-left:10px;background-color:' + ssbgcolor" @click="linkDownload">下载Chrome
          </div>
        </div>

      </div>
      <div class="pgl-main" :style="{ height: boxHeight + 'px' }">
        <div class="pglm-title">
          <div :class="rbNum == 1 ? 'actpglmt-item' : 'pglmt-item'"
            :style="rbNum == 1 ? 'font-weight: 600;border-bottom: ' + ssbgcolor + ' 2px solid;color:' + ssbgcolor : ''"
            @click="rbNum = 1">
            <i class="iconfont htoolsz opa" @click="openOftenModel" v-show="rbNum == 1"></i>常用功能
          </div>
          <div :class="rbNum == 2 ? 'actpglmt-item' : 'pglmt-item'"
            :style="rbNum == 2 ? 'font-weight: 600;border-bottom: ' + ssbgcolor + ' 2px solid;color:' + ssbgcolor : ''"
            @click="rbNum = 2">关键数据</div>
        </div>
        <div v-show="rbNum == 1" class="pglm-main">
          <div v-for="num in useOften2" :key="num.code" class="pglmm-item" @click="toPage(num)">
            <div class="pglmmi-img"><img :src="num.src"></div>
            <div class="pglmmi-name">{{ num.name }}</div>
          </div>
        </div>
        <div v-show="rbNum == 2" class="pglm-main2">
          <div class="pglmm-i">库存总量：</div>
          <div class="pglmm-i hasb">库存成本：</div>
          <div class="pglmm-i">现金：</div>
          <div class="pglmm-i hasb">银行存款：</div>
          <div class="pglmm-i">客户欠款：</div>
          <div class="pglmm-i hasb">供应商欠款：</div>
          <div class="pglmm-i">销售收入（本月）：</div>
          <div class="pglmm-i hasb">销售毛利（本月）：</div>
          <div class="pglmm-i">采购金额（本月）：</div>
          <div class="pglmm-i hasb">商品种类（本月）：</div>
        </div>
      </div>
    </div>
    <vxe-modal v-model="showOften" title="选择常用功能（最多8个）" height="580" width="900">
      <div class="often_model">
        <div class="model_select">
          <div v-for="(i, index) in useOften" :key="index" class="often_item">
            <div class="often_item_img">
              <img :src="i.src" :alt="i.name" />
            </div>
            <div class="often_item_name">{{ i.name }}</div>
          </div>
        </div>
        <div class="model_list">
          <div v-for="(i, index) in toolList" class="modelm_list_item" :key="index">
            <div class="list_title">{{ i.title }}</div>
            <div class="list_itemBox">
              <div v-for="(i1, index1) in i.children" :key="index1"
                :class="[i1.checked ? 'list_item checkeditem' : 'list_item']">
                <div class="item_change" @click="addOften(i1)"><i class="iconfont"
                    :class="i1.checked ? 'dxxz' : 'dxwxz'" style="font-size:22px"></i></div>
                <div class="item_text">
                  <span>{{ i1.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="model_btn">
          <vxe-button size="mini" status="info" style="width: 20%;height: 30px;" content="取消"
            @click="cancel"></vxe-button>
          <vxe-button size="mini" style="width: 20%;height: 30px;background: #316dca;color: #fff;" @click="comfirm"
            content="确认"></vxe-button>
        </div>
      </div>
    </vxe-modal>
  </div>
</template>

<script>
import axios from "axios";
import RowNca from '../../components/gongju/Row-nca'
import NavNca from '../../components/gongju/Nav-nca'
import ChartNca from '../../components/gongju/Chart-nca'
import { dateChange } from '../../assets/unit/util';
import { version } from "../../index";
var echarts = require('echarts/lib/echarts');
// 引入柱状图
require('echarts/lib/chart/bar');
// 引入提示框和标题组件
require('echarts/lib/component/tooltip');
require('echarts/lib/component/title');

export default {
  components: { RowNca, NavNca, ChartNca },
  data() {
    return {
      ssbgcolor: this.$Store.state.bgcolor,
      // 头部
      ghList: [
        { name: 'XY0245522', famount: 1000000 },
        { name: 'skuhjkjdiu', famount: 900000 },
        { name: 'iuafjnoiv', famount: 800000 },
        { name: 'alfjkdjf', famount: 700000 },
        { name: 'doiukjseoi5', famount: 600000 },
        { name: 'XY0245522', famount: 50000 },
        { name: 'XY0245522', famount: 4000 },
        { name: 'XY0245522', famount: 1000 },
        { name: 'XY0245522', famount: 100 },
        { name: 'XY0245522', famount: 12 }
      ],
      timeDate: '近七天',
      ChartNcaname: '销售对比分析',
      ChartNcakey: '102',
      ChartNcaobj: {
        color: ['#FC8556', '#519ABA', '#AE457D', '#FF0087', '#FFBF00'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          data: ['Line 1', 'Line 2']
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: 'Line 1',
            type: 'line',
            smooth: true,
            lineStyle: {
              width: 0
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(128, 255, 165)'
              }, {
                offset: 1,
                color: 'rgba(1, 191, 236)'
              }])
            },
            emphasis: {
              focus: 'series'
            },
            data: [140, 232, 101, 264, 90, 340, 250]
          },
          {
            name: 'Line 2',
            type: 'line',
            smooth: true,
            lineStyle: {
              width: 0
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(0, 221, 255)'
              }, {
                offset: 1,
                color: 'rgba(77, 119, 255)'
              }])
            },
            emphasis: {
              focus: 'series'
            },
            data: [120, 282, 111, 234, 220, 340, 310]
          }
        ]
      },
      toolList: [],
      showOften: false,
      useOften: [],
      useOften2: [],
      rbNum: 1,
      showMore: false,
      canvasCode: 'xh',
      canvasList: [{ name: '销货', code: 'xh' }, { name: '购货', code: 'gh' }, { name: '仓库', code: 'ck' }],
      topRlist: [
        { num: 0, code: 'kcyj', name: '库存预警', color: '#FC8556', naviid: 4111 },
        { num: 0, code: 'wfhxsdd', name: '未发货销售订单', color: '#F8BB39', naviid: 2131 },
        { num: 0, code: 'jrghbs', name: '今日购货笔数', color: '#47C056', naviid: 2321 },
        { num: 0, code: 'jrxhbs', name: '今日销货笔数', color: '#5B8FD4', naviid: 2311 },
        { num: 0, code: 'jrfkbs', name: '今日付款笔数', color: '#FC8556', naviid: 2313 },
        { num: 0, code: 'jrskbs', name: '今日收款笔数', color: '#F8BB39', naviid: 2323 },
      ],
      flinkid: -1,
      gocid: -1,
    }
  },

  computed: {
    boxHeight() {
      return this.$Store.state.htmlheight - 270;
    },
    rightWidth() {
      return this.$Store.state.htmlWidth - 500;
    },
    mainWidth() {
      return this.$Store.state.htmlWidth - 150;
    },
  },
  mounted() {
  },
  created() {
    this.flinkid = JSON.parse(localStorage.getItem("agtuserinfo")).flinkid;
    this.gocid = JSON.parse(localStorage.getItem("agtuserinfo")).fgocid ?
      JSON.parse(localStorage.getItem("agtuserinfo")).fgocid :
      JSON.parse(localStorage.getItem("agtuserinfo")).fcorp.gocid;
    this.getUseroften();
    this.handleCommand('one');
    this.setOftenColumns();
  },
  methods: {
    // 获取常用功能
    setOftenColumns() {
      if (this.$Datalist.toolList && this.$Datalist.toolList.length) {
        this.toolList = [];
        JSON.parse(JSON.stringify(this.$Datalist.toolList)).forEach(item => {
          if (item.title.indexOf("设置") == -1) {
            let itemObj = {
              title: "",
              children: []
            };
            itemObj["title"] = item.title;
            if (item.children && item.children.length) {
              item.children.forEach(items => {
                if (items && (items.children || items.list)) {
                  if (items.name.indexOf("报表") == -1) {
                    const arr = items.children || items.list;
                    itemObj["children"] = itemObj["children"].concat(arr);
                  } else if (item.title.indexOf("报表") != -1) {
                    const arr = items.children || items.list;
                    itemObj["children"] = itemObj["children"].concat(arr);
                  }
                }
              });
            }
            this.toolList.push(itemObj);
          }
        });
      }
    },
    // 下载打印插件
    async downloadPlugins() {
      // 获取当前经销商绑定的ERP用户
      const erplinkid = await this.getBindErpuser();
      if (erplinkid) {
        // 通过模拟a标签来自定义文件名下载
        const fileName = '打印插件.zip'; // 自定义的文件名
        const url = `https://ncktc.obs.cn-south-1.myhuaweicloud.com/print/${erplinkid}.zip`;
        fetch(url).then((res) => res.blob()).then((blod) => {
          // 创建一个隐藏的 a 标签  
          const a = document.createElement("a");
          a.href = URL.createObjectURL(blod);
          a.download = fileName; // 设置下载的文件名  
          a.style.display = "none"; // 隐藏这个链接  
          document.body.appendChild(a); // 将这个链接添加到 DOM 中 
          a.click(); // 模拟点击这个链接  
          document.body.removeChild(a); // 然后从 DOM 中移除这个链接  
        });
      } else {
        this.$alert("获取打印插件失败！", "错误提示", {confirmButtonText: '确定', type: "error"});
      }
    },
    // 获取当前经销商绑定的ERP客户
    getBindErpuser() {
      const objs = {
        system: "agt",
        visit: "web",
        linkid: JSON.parse(localStorage.getItem("agtcominfo")).linkid,
        keyword: "brandlist",
        keyname: "",
        gocid: -1,
        version: version
      };
      return new Promise(reslove => {
        axios.post("boss/info/find", objs).then(res => {
          if (res.data.code === 0 && res.data.data && res.data.data.length > 0) {
            reslove(res.data.data[0].flinkid);
          } else {
            reslove(0);
          }
        }).catch(error => {
          reslove(0);
        });
      });
    },

    handleCommand(e) {
      let url = 'rpt/find'
      let obj = {}

      let keyword = ''
      if (e == 'one') {
        this.timeDate = '近七天'
        if (this.canvasCode == 'gh') {
          this.ChartNcaname = '采购对比分析'
          let data = new Date().getTime()
          let beg = dateChange('date', data - 518400000)
          let end = dateChange('date', data)

          let doid = 2321
          let interval = 'day'
          keyword = 'agt/bill/sum/bydate'
          let arr0 = [dateChange('date1', data - 518400000), dateChange('date1', data - 432000000), dateChange('date1', data - 345600000), dateChange('date1', data - 259200000), dateChange('date1', data - 172800000), dateChange('date1', data - 86400000), dateChange('date1', data)]
          obj = {
            "donaviid": doid,
            "interval": interval,
            "keyword": keyword,
            "naviid": 5101,
            "pageno": 1,
            "pagesize": 20,
            "shownull": true,
            "style": 'yyyy-mm-dd',
            "system": 'agt',
            "visit": 'web',
            "filter": {
              "fdate.date>=": beg,
              "fdate.date<=": end,
            },
            "linkid": this.flinkid,
            "gocid": this.gocid,
            "version": version
          }
          let serdata = []
          axios.post(url, obj).then(res => {
            if (res.data.code == 0) {
              console.log(res.data.config)
              res.data.config.forEach(el => {
                let num = 0
                el.data.forEach(all => {
                  num = Number(num) + Number(all)
                })
                if (el.name == '金额') {
                  let item = {
                    name: '采购入库' + num,
                    type: 'line',
                    smooth: true,
                    lineStyle: {
                      width: 2
                    },
                    showSymbol: false,
                    areaStyle: {
                      opacity: 0.4,
                      color: '#FC8556'
                    },
                    emphasis: {
                      focus: 'series'
                    },
                    data: el.data
                  }
                  serdata.push(item)
                } else if (el.name == '退货金额') {
                  let num = 0
                  let tharr = []
                  el.data.forEach(all => {
                    all = 0 - Number(all)
                    num = Number(num) + Number(all)
                    tharr.push(all)
                  })
                  let item = {
                    name: '采购退货' + num,
                    type: 'line',
                    smooth: true,
                    lineStyle: {
                      width: 2
                    },
                    showSymbol: false,
                    areaStyle: {
                      opacity: 0.4,
                      color: '#519ABA'
                    },
                    emphasis: {
                      focus: 'series'
                    },
                    data: tharr
                  }
                  serdata.push(item)
                } else if (el.name == '合计金额') {
                  let num = 0
                  el.data.forEach(all => {
                    num = Number(num) + Number(all)
                  })
                  let item = {
                    name: '采购总额' + num,
                    type: 'line',
                    smooth: true,
                    lineStyle: {
                      width: 2
                    },
                    showSymbol: false,
                    areaStyle: {
                      opacity: 0.4,
                      color: '#AE457D'
                    },
                    emphasis: {
                      focus: 'series'
                    },
                    data: el.data
                  }
                  serdata.push(item)
                }
              })
              let datalist1 = []
              serdata.forEach((serel) => {
                datalist1.push(serel.name)
              })
              this.ChartNcaobj = {
                color: ['#FC8556', '#519ABA', '#AE457D', '#FF0087', '#FFBF00'],
                tooltip: {
                  trigger: 'axis',
                  axisPointer: {
                    type: 'cross',
                    label: {
                      backgroundColor: '#6a7985'
                    }
                  }
                },
                legend: {
                  data: datalist1
                },
                toolbox: {
                  feature: {
                    saveAsImage: {}
                  }
                },
                grid: {
                  left: '3%',
                  right: '4%',
                  bottom: '3%',
                  containLabel: true
                },
                xAxis: [
                  {
                    type: 'category',
                    boundaryGap: false,
                    data: arr0
                  }
                ],
                yAxis: [
                  {
                    type: 'value'
                  }
                ],
                series: serdata
              }
              setTimeout(() => {
                this.$refs.chart.drawLine()
              }, 200)
            } else {
              this.$alert(res.data.message, "错误提示", {confirmButtonText: '确定', type: "error"});
            }
          })


        } else if (this.canvasCode == 'xh') {
          this.ChartNcaname = '销售对比分析'
          let data = new Date().getTime()
          let beg = dateChange('date', data - 518400000)
          let end = dateChange('date', data)
          let doid = 2311
          let interval = 'day'
          keyword = 'agt/bill/sum/bydate'
          let arr0 = [dateChange('date1', data - 518400000), dateChange('date1', data - 432000000), dateChange('date1', data - 345600000), dateChange('date1', data - 259200000), dateChange('date1', data - 172800000), dateChange('date1', data - 86400000), dateChange('date1', data)]
          obj = {
            "donaviid": doid,
            "interval": interval,
            "keyword": keyword,
            "naviid": 5101,
            "pageno": 1,
            "pagesize": 20,
            "shownull": true,
            "style": 'yyyy-mm-dd',
            "system": 'agt',
            "visit": 'web',
            "filter": {
              "fdate.date>=": beg,
              "fdate.date<=": end,
            },
            "linkid": this.flinkid,
            "gocid": this.gocid,
            "version": version
          }
          let serdata = []
          axios.post(url, obj).then(res => {
            if (res.data.code == 0) {
              console.log(res.data.config)
              res.data.config.forEach(el => {
                if (el.name == '金额') {
                  let num = 0
                  el.data.forEach(all => {
                    num = Number(num) + Number(all)
                  })
                  let item = {
                    name: '销售出库' + num,
                    type: 'line',
                    smooth: true,
                    lineStyle: {
                      width: 2
                    },
                    showSymbol: false,
                    areaStyle: {
                      opacity: 0.4,
                      color: '#FC8556'
                    },
                    emphasis: {
                      focus: 'series'
                    },
                    data: el.data
                  }
                  serdata.push(item)
                } else if (el.name == '退货金额') {
                  let num = 0
                  let tharr = []
                  el.data.forEach(all => {
                    all = 0 - Number(all)
                    num = Number(num) + Number(all)
                    tharr.push(all)
                  })
                  let item = {
                    name: '销售退货' + num,
                    type: 'line',
                    smooth: true,
                    lineStyle: {
                      width: 2
                    },
                    showSymbol: false,
                    areaStyle: {
                      opacity: 0.4,
                      color: '#519ABA'
                    },
                    emphasis: {
                      focus: 'series'
                    },
                    data: tharr
                  }
                  serdata.push(item)
                } else if (el.name == '合计金额') {
                  let num = 0
                  el.data.forEach(all => {
                    num = Number(num) + Number(all)
                  })
                  let item = {
                    name: '销售总额' + num,
                    type: 'line',
                    smooth: true,
                    lineStyle: {
                      width: 2
                    },
                    showSymbol: false,
                    areaStyle: {
                      opacity: 0.4,
                      color: '#AE457D'
                    },
                    emphasis: {
                      focus: 'series'
                    },
                    data: el.data
                  }
                  serdata.push(item)
                }
              })
              let datalist1 = []
              serdata.forEach((serel) => {
                datalist1.push(serel.name)
              })
              this.ChartNcaobj = {
                color: ['#FC8556', '#519ABA', '#AE457D', '#FF0087', '#FFBF00'],
                tooltip: {
                  trigger: 'axis',
                  axisPointer: {
                    type: 'cross',
                    label: {
                      backgroundColor: '#6a7985'
                    }
                  }
                },
                legend: {
                  data: datalist1
                },
                toolbox: {
                  feature: {
                    saveAsImage: {}
                  }
                },
                grid: {
                  left: '3%',
                  right: '4%',
                  bottom: '3%',
                  containLabel: true
                },
                xAxis: [
                  {
                    type: 'category',
                    boundaryGap: false,
                    data: arr0
                  }
                ],
                yAxis: [
                  {
                    type: 'value'
                  }
                ],
                series: serdata
              }
              setTimeout(() => {
                this.$refs.chart.drawLine()
              }, 200)
            } else {
              this.$alert(res.data.message, "错误提示", {confirmButtonText: '确定', type: "error"});
            }
          })


        } else if (this.canvasCode == 'ck') {
          this.ChartNcaname = '库存数量分布'
          this.ChartNcaobj = {
            tooltip: {
              trigger: 'item',
              formatter: '{a} <br/>{b} : {c} ({d}%)'
            },
            legend: {
              orient: 'vertical',
              left: 'left',
              data: ['经销商', '普通客户', '员工客户', '厂商', '公司客户']
            },
            series: [
              {
                name: '客户来源',
                type: 'pie',
                radius: '55%',
                center: ['50%', '60%'],
                data: [
                  { value: 335, name: '经销商' },
                  { value: 310, name: '普通客户' },
                  { value: 234, name: '员工客户' },
                  { value: 135, name: '厂商' },
                  { value: 1548, name: '公司客户' }
                ],
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
                }
              }
            ]
          }
          setTimeout(() => {
            this.$refs.chart.drawLine()
            // this.$refs.chart1.drawLine()
          }, 200)
        }
      } else if (e == 'two') {
        this.timeDate = '近七周'
        if (this.canvasCode == 'xh') {
          this.ChartNcaname = '销售对比分析'
          this.ChartNcaobj = {
            xAxis: {
              data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sat1']
            },
            yAxis: {},
            series: [{
              name: '销量',
              type: 'bar',
              data: [52, 50, 35, 90, 12, 80, 50]
            }]
          }
          setTimeout(() => {
            this.$refs.chart.drawLine()
          }, 200)
        } else if (this.canvasCode == 'gh') {
          this.ghList = [
            { name: 'XY0245522', famount: 10002000 },
            { name: 'skuhjkjdiu', famount: 900000 },
            { name: 'iuafjnoiv', famount: 800000 },
            { name: 'alfjkdjf', famount: 700000 },
            { name: 'XY0245522', famount: 600000 },
            { name: 'alfjkdjf', famount: 50000 },
            { name: 'XY0245522', famount: 4000 },
            { name: 'XY0245522', famount: 1000 },
            { name: 'alfjkdjf', famount: 100 },
            { name: 'iuafjnoiv', famount: 12 },
          ]
        } else if (this.canvasCode == 'ck') {
          this.ChartNcaname = '库存数量分布'
          this.ChartNcaobj = {
            tooltip: {
              trigger: 'item',
              formatter: '{a} <br/>{b} : {c} ({d}%)'
            },
            legend: {
              orient: 'vertical',
              left: 'left',
              data: ['经销商', '普通客户', '员工客户', '厂商', '公司客户']
            },
            series: [
              {
                name: '客户来源',
                type: 'pie',
                radius: '55%',
                center: ['50%', '60%'],
                data: [
                  { value: 556, name: '经销商' },
                  { value: 310, name: '普通客户' },
                  { value: 233, name: '员工客户' },
                  { value: 135, name: '厂商' },
                  { value: 23, name: '公司客户' }
                ],
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
                }
              }
            ]
          }
          setTimeout(() => {
            this.$refs.chart.drawLine()
          }, 200)
        }

      } else if (e == 'three') {
        this.timeDate = '近七月'
        if (this.canvasCode == 'gh') {
          this.ChartNcaname = '采购对比分析'
          let beg = ''
          let end = ''
          let doid = 2321
          let interval = 'month'
          let date = new Date();
          let arrrev = [];
          let month = date.getMonth() + 1;
          let yy = Number(String(date.getFullYear()).slice(-2)) + 2000;
          console.log(yy)

          for (let i = 0; i < 7; i++) {
            if (month < 10) {
              arrrev.push(yy + '/0' + month);
            } else {
              arrrev.push(yy + '/' + month);
            }
            if (month-- == 1) {
              month = 12;
              yy--
            }
          }
          let arr0 = arrrev.reverse()
          console.log(arr0)
          beg = arr0[0].split('/')[0] + '-' + arr0[0].split('/')[1] + '-01'
          if (month == 1 || month == 3 || month == 5 || month == 7 || month == 8 || month == 10 || month == 12) {
            end = arr0[6].split('/')[0] + '-' + arr0[6].split('/')[1] + '-31'
          } else {
            end = arr0[6].split('/')[0] + '-' + arr0[6].split('/')[1] + '-30'
          }

          keyword = 'agt/bill/sum/bydate'
          obj = {
            "donaviid": doid,
            "interval": interval,
            "keyword": keyword,
            "naviid": 5101,
            "pageno": 1,
            "pagesize": 20,
            "shownull": true,
            "style": 'yyyy-mm',
            "system": 'agt',
            "visit": 'web',
            "filter": {
              "fdate.date>=": beg,
              "fdate.date<=": end,
            },
            "linkid": this.flinkid,
            "gocid": this.gocid,
            "version": version
          }
          let serdata = []
          axios.post(url, obj).then(res => {
            if (res.data.code == 0) {
              console.log(res.data.config)
              res.data.config.forEach(el => {
                let num = 0
                el.data.forEach(all => {
                  num = Number(num) + Number(all)
                })
                if (el.name == '金额') {
                  let item = {
                    name: '采购入库' + num,
                    type: 'line',
                    smooth: true,
                    lineStyle: {
                      width: 2
                    },
                    showSymbol: false,
                    areaStyle: {
                      opacity: 0.4,
                      color: '#FC8556'
                    },
                    emphasis: {
                      focus: 'series'
                    },
                    data: el.data
                  }
                  serdata.push(item)
                } else if (el.name == '退货金额') {
                  let num = 0
                  let tharr = []
                  el.data.forEach(all => {
                    all = 0 - Number(all)
                    num = Number(num) + Number(all)
                    tharr.push(all)
                  })
                  let item = {
                    name: '采购退货' + num,
                    type: 'line',
                    smooth: true,
                    lineStyle: {
                      width: 2
                    },
                    showSymbol: false,
                    areaStyle: {
                      opacity: 0.4,
                      color: '#519ABA'
                    },
                    emphasis: {
                      focus: 'series'
                    },
                    data: tharr
                  }
                  serdata.push(item)
                } else if (el.name == '合计金额') {
                  let num = 0
                  el.data.forEach(all => {
                    num = Number(num) + Number(all)
                  })
                  let item = {
                    name: '采购总额' + num,
                    type: 'line',
                    smooth: true,
                    lineStyle: {
                      width: 2
                    },
                    showSymbol: false,
                    areaStyle: {
                      opacity: 0.4,
                      color: '#AE457D'
                    },
                    emphasis: {
                      focus: 'series'
                    },
                    data: el.data
                  }
                  serdata.push(item)
                }
              })
              let datalist1 = []
              serdata.forEach((serel) => {
                datalist1.push(serel.name)
              })
              this.ChartNcaobj = {
                color: ['#FC8556', '#519ABA', '#AE457D', '#FF0087', '#FFBF00'],
                tooltip: {
                  trigger: 'axis',
                  axisPointer: {
                    type: 'cross',
                    label: {
                      backgroundColor: '#6a7985'
                    }
                  }
                },
                legend: {
                  data: datalist1
                },
                toolbox: {
                  feature: {
                    saveAsImage: {}
                  }
                },
                grid: {
                  left: '3%',
                  right: '4%',
                  bottom: '3%',
                  containLabel: true
                },
                xAxis: [
                  {
                    type: 'category',
                    boundaryGap: false,
                    data: arr0
                  }
                ],
                yAxis: [
                  {
                    type: 'value'
                  }
                ],
                series: serdata
              }
              setTimeout(() => {
                this.$refs.chart.drawLine()
              }, 200)
            } else {
              this.$alert(res.data.message, "错误提示", {confirmButtonText: '确定', type: "error"});
            }
          })


        } else if (this.canvasCode == 'xh') {
          this.ChartNcaname = '销售对比分析'
          let beg = ''
          let end = ''
          let doid = 2311
          let interval = 'month'
          let date = new Date();
          let arrrev = [];
          let month = date.getMonth() + 1;
          let yy = Number(String(date.getFullYear()).slice(-2)) + 2000;
          console.log(yy)

          for (let i = 0; i < 7; i++) {
            if (month < 10) {
              arrrev.push(yy + '/0' + month);
            } else {
              arrrev.push(yy + '/' + month);
            }
            if (month-- == 1) {
              month = 12;
              yy--
            }
          }
          let arr0 = arrrev.reverse()
          console.log(arr0)
          beg = arr0[0].split('/')[0] + '-' + arr0[0].split('/')[1] + '-01'
          if (month == 1 || month == 3 || month == 5 || month == 7 || month == 8 || month == 10 || month == 12) {
            end = arr0[6].split('/')[0] + '-' + arr0[6].split('/')[1] + '-31'
          } else {
            end = arr0[6].split('/')[0] + '-' + arr0[6].split('/')[1] + '-30'
          }
          keyword = 'agt/bill/sum/bydate'
          obj = {
            "donaviid": doid,
            "interval": interval,
            "keyword": keyword,
            "naviid": 5101,
            "pageno": 1,
            "pagesize": 20,
            "shownull": true,
            "style": 'yyyy-mm',
            "system": 'agt',
            "visit": 'web',
            "filter": {
              "fdate.date>=": beg,
              "fdate.date<=": end,
            },
            "linkid": this.flinkid,
            "gocid": this.gocid,
            "version": version
          }
          let serdata = []
          axios.post(url, obj).then(res => {
            if (res.data.code == 0) {
              console.log(res.data.config)
              res.data.config.forEach(el => {
                if (el.name == '金额') {
                  let num = 0
                  el.data.forEach(all => {
                    num = Number(num) + Number(all)
                  })
                  let item = {
                    name: '销售出库' + num,
                    type: 'line',
                    smooth: true,
                    lineStyle: {
                      width: 2
                    },
                    showSymbol: false,
                    areaStyle: {
                      opacity: 0.4,
                      color: '#FC8556'
                    },
                    emphasis: {
                      focus: 'series'
                    },
                    data: el.data
                  }
                  serdata.push(item)
                } else if (el.name == '退货金额') {
                  let num = 0
                  let tharr = []
                  el.data.forEach(all => {
                    all = 0 - Number(all)
                    num = Number(num) + Number(all)
                    tharr.push(all)
                  })
                  let item = {
                    name: '销售退货' + num,
                    type: 'line',
                    smooth: true,
                    lineStyle: {
                      width: 2
                    },
                    showSymbol: false,
                    areaStyle: {
                      opacity: 0.4,
                      color: '#519ABA'
                    },
                    emphasis: {
                      focus: 'series'
                    },
                    data: tharr
                  }
                  serdata.push(item)
                } else if (el.name == '合计金额') {
                  let num = 0
                  el.data.forEach(all => {
                    num = Number(num) + Number(all)
                  })
                  let item = {
                    name: '销售总额' + num,
                    type: 'line',
                    smooth: true,
                    lineStyle: {
                      width: 2
                    },
                    showSymbol: false,
                    areaStyle: {
                      opacity: 0.4,
                      color: '#AE457D'
                    },
                    emphasis: {
                      focus: 'series'
                    },
                    data: el.data
                  }
                  serdata.push(item)
                }
              })
              let datalist1 = []
              serdata.forEach((serel) => {
                datalist1.push(serel.name)
              })
              this.ChartNcaobj = {
                color: ['#FC8556', '#519ABA', '#AE457D', '#FF0087', '#FFBF00'],
                tooltip: {
                  trigger: 'axis',
                  axisPointer: {
                    type: 'cross',
                    label: {
                      backgroundColor: '#6a7985'
                    }
                  }
                },
                legend: {
                  data: datalist1
                },
                toolbox: {
                  feature: {
                    saveAsImage: {}
                  }
                },
                grid: {
                  left: '3%',
                  right: '4%',
                  bottom: '3%',
                  containLabel: true
                },
                xAxis: [
                  {
                    type: 'category',
                    boundaryGap: false,
                    data: arr0
                  }
                ],
                yAxis: [
                  {
                    type: 'value'
                  }
                ],
                series: serdata
              }
              setTimeout(() => {
                this.$refs.chart.drawLine()
              }, 200)
            } else {
              this.$alert(res.data.message, "错误提示", {confirmButtonText: '确定', type: "error"});
            }
          })


        } else if (this.canvasCode == 'ck') {
          this.ChartNcaname = '库存数量分布'
          this.ChartNcaobj = {
            tooltip: {
              trigger: 'item',
              formatter: '{a} <br/>{b} : {c} ({d}%)'
            },
            legend: {
              orient: 'vertical',
              left: 'left',
              data: ['经销商', '普通客户', '员工客户', '厂商', '公司客户']
            },
            series: [
              {
                name: '客户来源',
                type: 'pie',
                radius: '55%',
                center: ['50%', '60%'],
                data: [
                  { value: 335, name: '经销商' },
                  { value: 310, name: '普通客户' },
                  { value: 234, name: '员工客户' },
                  { value: 135, name: '厂商' },
                  { value: 1548, name: '公司客户' }
                ],
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
                }
              }
            ]
          }
          setTimeout(() => {
            this.$refs.chart.drawLine()
            // this.$refs.chart1.drawLine()
          }, 200)
        }
      }
    },
    getUseroften() {
      let data = {
        system: 'agt',
        visit: 'web',
        douserid: localStorage.getItem('agtuserinfo').fuserid,
        keyword: 'report',
        linkid: this.flinkid,
        gocid: this.gocid,
        version: version
      };
      axios.post('user/keyword/find', data).then(res => {
        if (res.data.code == 0) {
          this.useOften = JSON.parse(JSON.stringify(res.data.data));
          res.data.data.some((item, index) => {
            this.getobsUrl(this.toolList, item.fnaviid, item);
          });
          const findex=res.data.data.findIndex(item=>item.fname=="总部库存")
          if(findex==-1){
            res.data.data.push({
              checked:true,
              code:'zbkc',
              fname:'总部库存',
              fnaviid:1414,
              name:'总部库存',
              src:"https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/2401.png"
            })
          }
          this.useOften2 = res.data.data;
        } else {
          this.$alert(res.data.message, "错误提示", {confirmButtonText: '确定', type: "error"});;
        }
      });
    },
    getobsUrl(array, id, data) {
      if (!array || !array.length) return;
      array.forEach(el => {
        if (el.fnaviid == id) {
          data.src = el.src ? el.src : data.src;
          if (el.fobsurl) {
            el.fobsurl = el.item.substring(1, el.fobsurl.length)
            let obsClient = new this.$ObsClient({
              access_key_id: "QTEZALFEWXYLBIPF1ZXH",
              secret_access_key: "hgh3XEUxF0bqt2Klu9DNbnG9goAdj2HqoHFL8RfK",
              server: "https://obs.cn-south-1.myhuaweicloud.com",
            });
            obsClient.getObject({
              Bucket: "ncktc",
              Key: `${el.fobsurl}`,
              SaveByType: "file",
            }, (err, result) => {
              if (err) {
                console.error("Error-->" + err);
              } else {
                data.src = result.InterfaceResult.Content.SignedUrl;
              }
            });
          }
        } else {
          const children = el.children || el.list;
          this.getobsUrl(children, id, data);
        }
      });
    },
    toPage(e) {
      console.log(e)
      this.$emit('topage', e)
    },
    openOftenModel() {
      this.showOften = true;
      this.setOftenColumns();
      this.useOften2.forEach(el => {
        this.toolList.forEach(ell => {
          ell.children.forEach(elll => {
            if (el.name == elll.name) {
              elll.checked = true;
            } else {
              elll.checked = false;
            }
          })
        })
      });
    },
    comfirm() {
      this.useOften2 = JSON.parse(JSON.stringify(this.useOften));
      this.showOften = false;
      let data = {
        "system": "agt",
        "visit": "web",
        "douserid": localStorage.getItem('agtuserinfo').fuserid,
        "keyword": "report",
        "data": this.useOften,
        "linkid": this.flinkid,
        "gocid": this.gocid,
        "version": version
      }
      axios.post('user/keyword/save', data).then(res => {
        if (res.data.code == 0) {
          this.$message.success('修改成功');
        } else {
          this.$alert(res.data.message, "错误提示", {confirmButtonText: '确定', type: "error"});;
        }
      });
    },
    cancel() {
      this.useOften = JSON.parse(JSON.stringify(this.useOften2));
      this.showOften = false;
      this.setOftenColumns(); //重新设置模块
    },
    addOften(e) {
      if (e.checked) {
        e.checked = false;
        if (this.useOften.length) {
          this.useOften.forEach((el, index) => {
            if (el.code == e.code) {
              this.useOften.splice(index, 1);
            }
          });
        }
      } else {
        if (this.useOften.length > 7) {
          this.$alert("已达到最大数量", "错误提示", {confirmButtonText: '确定', type: "error"});
        } else {
          let issave = false;
          if (this.useOften.length) {
            this.useOften.forEach((el, index) => {
              if (el.code == e.code) {
                this.$alert("该模块已存在", "错误提示", {confirmButtonText: '确定', type: "error"});
                issave = true;
              }
            });
          }
          setTimeout(() => {
            if (issave) {
              e.checked = true;
            } else {
              e.checked = true;
              if (this.useOften.length) {
                this.useOften.push({ ...e, src: `https://ncktc.obs.cn-south-1.myhuaweicloud.com/erp/navi/${e.fnaviid}.png` });
              } else {
                this.useOften = [{ ...e, src: `https://ncktc.obs.cn-south-1.myhuaweicloud.com/erp/navi/${e.fnaviid}.png` }];
              }
            }
          }, 200);
        }
      }
    },
    canvasClick(e) {
      this.canvasCode = e.code
      this.timeDate = '近七天'
      let url = 'rpt/find'
      if (e.code == 'xh') {
        this.ChartNcaname = '销售对比分析'
        let data = new Date().getTime()
        let beg = dateChange('date', data - 518400000)
        let end = dateChange('date', data)

        let doid = 2311
        let interval = 'day'
        let keyword = 'agt/bill/sum/bydate'
        let arr0 = [dateChange('date1', data - 518400000), dateChange('date1', data - 432000000), dateChange('date1', data - 345600000), dateChange('date1', data - 259200000), dateChange('date1', data - 172800000), dateChange('date1', data - 86400000), dateChange('date1', data)]
        let obj = {
          "donaviid": doid,
          "interval": interval,
          "keyword": keyword,
          "naviid": 5101,
          "pageno": 1,
          "pagesize": 20,
          "shownull": true,
          "style": 'yyyy-mm-dd',
          "system": 'agt',
          "visit": 'web',
          "filter": {
            "fdate.date>=": beg,
            "fdate.date<=": end,
          },
          "linkid": this.flinkid,
          "gocid": this.gocid,
          "version": version
        }
        let serdata = []
        axios.post(url, obj).then(res => {
          if (res.data.code == 0) {
            console.log(res.data.config)
            res.data.config.forEach(el => {
              if (el.name == '金额') {
                let num = 0
                el.data.forEach(all => {
                  num = Number(num) + Number(all)
                })
                let item = {
                  name: '销售出库' + num,
                  type: 'line',
                  smooth: true,
                  lineStyle: {
                    width: 2
                  },
                  showSymbol: false,
                  areaStyle: {
                    opacity: 0.4,
                    color: '#FC8556'
                  },
                  emphasis: {
                    focus: 'series'
                  },
                  data: el.data
                }
                serdata.push(item)
              } else if (el.name == '退货金额') {
                let num = 0
                let tharr = []
                el.data.forEach(all => {
                  all = 0 - Number(all)
                  num = Number(num) + Number(all)
                  tharr.push(all)
                })
                let item = {
                  name: '销售退货' + num,
                  type: 'line',
                  smooth: true,
                  lineStyle: {
                    width: 2
                  },
                  showSymbol: false,
                  areaStyle: {
                    opacity: 0.4,
                    color: '#519ABA'
                  },
                  emphasis: {
                    focus: 'series'
                  },
                  data: tharr
                }
                serdata.push(item)
              } else if (el.name == '合计金额') {
                let num = 0
                el.data.forEach(all => {
                  num = Number(num) + Number(all)
                })
                let item = {
                  name: '销售总额' + num,
                  type: 'line',
                  smooth: true,
                  lineStyle: {
                    width: 2
                  },
                  showSymbol: false,
                  areaStyle: {
                    opacity: 0.4,
                    color: '#AE457D'
                  },
                  emphasis: {
                    focus: 'series'
                  },
                  data: el.data
                }
                serdata.push(item)
              }
            })
            let datalist1 = []
            serdata.forEach((serel) => {
              datalist1.push(serel.name)
            })
            this.ChartNcaobj = {
              color: ['#FC8556', '#519ABA', '#AE457D', '#FF0087', '#FFBF00'],
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'cross',
                  label: {
                    backgroundColor: '#6a7985'
                  }
                }
              },
              legend: {
                data: datalist1
              },
              toolbox: {
                feature: {
                  saveAsImage: {}
                }
              },
              grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
              },
              xAxis: [
                {
                  type: 'category',
                  boundaryGap: false,
                  data: arr0
                }
              ],
              yAxis: [
                {
                  type: 'value'
                }
              ],
              series: serdata
            }
            setTimeout(() => {
              this.$refs.chart.drawLine()
            }, 200)
          } else {
            this.$alert(res.data.message, "错误提示", {confirmButtonText: '确定', type: "error"});
          }
        })
      } else if (e.code == 'gh') {
        this.ChartNcaname = '采购对比分析'
        let data = new Date().getTime()
        let beg = dateChange('date', data - 518400000)
        let end = dateChange('date', data)
        let doid = 2321
        let interval = 'day'
        let keyword = 'agt/bill/sum/bydate'
        let arr0 = [dateChange('date1', data - 518400000), dateChange('date1', data - 432000000), dateChange('date1', data - 345600000), dateChange('date1', data - 259200000), dateChange('date1', data - 172800000), dateChange('date1', data - 86400000), dateChange('date1', data)]
        let obj = {
          "donaviid": doid,
          "interval": interval,
          "keyword": keyword,
          "naviid": 5101,
          "pageno": 1,
          "pagesize": 20,
          "shownull": true,
          "style": 'yyyy-mm-dd',
          "system": 'agt',
          "visit": 'web',
          "filter": {
            "fdate.date>=": beg,
            "fdate.date<=": end,
          },
          "linkid": this.flinkid,
          "gocid": this.gocid,
          "version": version
        }
        let serdata = []
        axios.post(url, obj).then(res => {
          if (res.data.code == 0) {
            console.log(res.data.config)
            res.data.config.forEach(el => {
              let num = 0
              el.data.forEach(all => {
                num = Number(num) + Number(all)
              })
              if (el.name == '金额') {
                let item = {
                  name: '采购入库' + num,
                  type: 'line',
                  smooth: true,
                  lineStyle: {
                    width: 2
                  },
                  showSymbol: false,
                  areaStyle: {
                    opacity: 0.4,
                    color: '#FC8556'
                  },
                  emphasis: {
                    focus: 'series'
                  },
                  data: el.data
                }
                serdata.push(item)
              } else if (el.name == '退货金额') {
                let num = 0
                let tharr = []
                el.data.forEach(all => {
                  all = 0 - Number(all)
                  num = Number(num) + Number(all)
                  tharr.push(all)
                })
                let item = {
                  name: '采购退货' + num,
                  type: 'line',
                  smooth: true,
                  lineStyle: {
                    width: 2
                  },
                  showSymbol: false,
                  areaStyle: {
                    opacity: 0.4,
                    color: '#519ABA'
                  },
                  emphasis: {
                    focus: 'series'
                  },
                  data: tharr
                }
                serdata.push(item)
              } else if (el.name == '合计金额') {
                let num = 0
                el.data.forEach(all => {
                  num = Number(num) + Number(all)
                })
                let item = {
                  name: '采购总额' + num,
                  type: 'line',
                  smooth: true,
                  lineStyle: {
                    width: 2
                  },
                  showSymbol: false,
                  areaStyle: {
                    opacity: 0.4,
                    color: '#AE457D'
                  },
                  emphasis: {
                    focus: 'series'
                  },
                  data: el.data
                }
                serdata.push(item)
              }
            })
            let datalist1 = []
            serdata.forEach((serel) => {
              datalist1.push(serel.name)
            })
            this.ChartNcaobj = {
              color: ['#FC8556', '#519ABA', '#AE457D', '#FF0087', '#FFBF00'],
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'cross',
                  label: {
                    backgroundColor: '#6a7985'
                  }
                }
              },
              legend: {
                data: datalist1
              },
              toolbox: {
                feature: {
                  saveAsImage: {}
                }
              },
              grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
              },
              xAxis: [
                {
                  type: 'category',
                  boundaryGap: false,
                  data: arr0
                }
              ],
              yAxis: [
                {
                  type: 'value'
                }
              ],
              series: serdata
            }
            setTimeout(() => {
              this.$refs.chart.drawLine()
            }, 200)
          } else {
            this.$alert(res.data.message, "错误提示", {confirmButtonText: '确定', type: "error"});
          }
        })

        setTimeout(() => {
          this.$refs.chart.drawLine()
        }, 200)
      } else if (e.code == 'ck') {
        this.ChartNcaname = '库存数量分布'
        this.ChartNcaobj = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            left: 'left',
            data: ['经销商', '普通客户', '员工客户', '厂商', '公司客户']
          },
          series: [
            {
              name: '客户来源',
              type: 'pie',
              radius: '55%',
              center: ['50%', '60%'],
              data: [
                { value: 335, name: '经销商' },
                { value: 310, name: '普通客户' },
                { value: 234, name: '员工客户' },
                { value: 135, name: '厂商' },
                { value: 1548, name: '公司客户' }
              ],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }
        setTimeout(() => {
          this.$refs.chart.drawLine()
        }, 200);
      }
    },
    linkDownload() {
      window.open('https://www.google.cn/intl/zh-CN/chrome/', '_blank')
    },
  }
}
</script>

<style lang="scss" scoped>
@import './index';

.gl-li {
  display: flex;
  width: 100%;
  justify-content: space-around;
  margin-bottom: 40px;
}

.ghl-item {
  position: relative;
  display: flex;
  width: 40%;
  justify-content: space-between;
  background: #EEEEEE;
  line-height: 38px;
  padding: 0 16px;
  box-sizing: border-box;
}

.gli-index {
  position: absolute;
  left: -30px;
  font-size: 30px;
}

.plugins {
  background-color: #fc8556;
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue